import { render, staticRenderFns } from "./New-footer.vue?vue&type=template&id=0ca88131&"
import script from "./New-footer.vue?vue&type=script&lang=js&"
export * from "./New-footer.vue?vue&type=script&lang=js&"
import style0 from "./New-footer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports